import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../utils/formatPrice';

export default function EkPaketler() {
  const packages = [
    {
      id: 1,
      subTitle: '1 Kişi 1 Gece',
      title: "Peter Pan'ın Gölgesi",
      price: '₺6000',
      description: 'Konferans öncesi veya sonrası için tek günlük konaklama fiyatıdır',
      features: [
        '1 gece ekstra konaklama',
        'Erken giriş veya geç çıkış imkanı',
      ],
      image: '/images/peter.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 2,
      subTitle: '2 Kişi 1 Gece',
      title: "Ariel'in Uykusu",
      price: '₺4500',
      description: 'Konferans öncesi veya sonrası için tek günlük konaklama fiyatıdır',
      features: [
        '1 gece ekstra konaklama',
        'Erken giriş veya geç çıkış imkanı',
      ],
      image: '/images/deniz_kizi.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 3,
      subTitle: '3 Kişi 1 Gece',
      title: "Teneke Adamın Kalbi",
      price: '₺4000',
      description: 'Konferans öncesi veya sonrası için tek günlük konaklama fiyatıdır',
      features: [
        '1 gece ekstra konaklama',
        'Erken giriş veya geç çıkış imkanı',
      ],
      image: '/images/teneke.webp',
      cta: 'Kayıtlar Kapandı',
    }
  ];

  return (
    <section className="py-5 paketler-page" style={{ backgroundColor: 'transparent' }}>
      <div className="container">
        <h1 className="text-center mb-5" style={{marginTop: '50px'}}>Ekstra Konaklama Paketleri</h1>
        <div className="row">
          {packages.map((pkg) => (
            <div className="col-lg-4 mb-4" key={pkg.id}>
              <div
                className={`card h-100 ${pkg.featured ? 'shadow-lg' : ''}`}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.08)', /* Transparent glass effect */
                  borderColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '24px',
                  backdropFilter: 'blur(12px)', /* Strong glassmorphism effect */
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  overflow: 'hidden', /* Ensure image doesn't break border radius */
                  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)'
                }}
              >
                <div className="pkg-header-container">
                  <h5 className="card-title ana-paketler-card-title" style={{ color: '#fff' }}>{pkg.title}</h5>
                </div>
                <div className="pkg-img-wrapper">
                  <img src={pkg.image} alt={pkg.title} className="card-img-top" style={{ objectFit: 'cover', height: '100%' }} />
                </div>
                <div className="card-body d-flex flex-column text-center" style={{ color: '#fff' }}>
                  <p className="ana-paketler-subtitle mb-2" style={{ color: '#fff' }}>{pkg.subTitle}</p>
                  {pkg.description && (
                    <p className="small" style={{ color: '#fff' }}>{pkg.description}</p>
                  )}
                  <div className="mb-4 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '75px' }}>
                    <div className="h3 mb-0" style={{ color: '#fff', fontWeight: 'bold' }}>{formatPrice(pkg.price)}</div>
                    <small style={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '0.8rem', marginTop: '4px' }}>(Kişi Başı Ücretidir)</small>
                  </div>
                  <ul className="list-unstyled mb-4 flex-grow-1">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className="mb-2" style={{ color: '#fff' }}>
                        <i className="bi bi-check-circle-fill text-white me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/kayit-ol"
                    className="btn w-100"
                    style={{
                      backgroundColor: pkg.featured ? '#742640' : 'transparent',
                      color: '#fff',
                      borderColor: '#fff',
                    }}
                  >
                    {pkg.cta}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
